import React, { PropsWithChildren } from "react";
import { useSession } from "../../../state/api/session/useSession";

export default function AsAdmin(p: PropsWithChildren<any>) {
  const { children } = p;

  const { session } = useSession();

  if (!session?.isAdmin) {
    return null;
  }
  
  return children;
}